import scrappingRoutes from './routes'

/* @ngInject */
const scrappingRoute = (
  $stateProvider
) => {
  $stateProvider
    .state(scrappingRoutes.index.path, {
      url: scrappingRoutes.index.url,
      redirectTo: scrappingRoutes.sale.index.path,
      template: require('./templates/index.html'),
      data: {
        pageTitle: 'Ferrailler',
      },
    })
}

export default scrappingRoute



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/scrapping/scrapping.routes.js